import React from 'react';
import AudioRecorder from './AudioRecorder';

function AudioAnswerQuestion({ question, value = '', onChange, disabled = false }) {
  return (
    <AudioRecorder 
      value={value} 
      onChange={onChange} 
      disabled={disabled}
      maxRecordingTime={question.max_duration || 120}
    />
  );
}

export default AudioAnswerQuestion;
